import {
  SUBSCRIPTION_STATUS_PAYMENT_FAILED,
  SUBSCRIPTION_STATUS_PAST_DUE,
  SUBSCRIPTION_STATUS_PIX_MANUAL,
} from './subscription-status';

/** Rótulo curto em PT-BR para exibir ao lado do plano (UI). */
export function subscriptionStatusShortLabelPt(
  status: string | null | undefined,
): string | null {
  if (status == null) return null;
  const s = status.trim().toLowerCase();
  if (s.length === 0) return null;

  const map: Record<string, string> = {
    active: 'ativo',
    trialing: 'período de testes',
    pending: 'pendente',
    authorized: 'autorizado',
    incomplete: 'aguardando confirmação',
    incomplete_expired: 'checkout expirado',
    canceled: 'cancelado',
    cancelled: 'cancelado',
    unpaid: 'pagamento pendente',
    paused: 'pausado',
    [SUBSCRIPTION_STATUS_PIX_MANUAL]: 'PIX manual',
    [SUBSCRIPTION_STATUS_PAST_DUE]: 'pagamento em atraso',
    [SUBSCRIPTION_STATUS_PAYMENT_FAILED]: 'falha no pagamento',
  };

  return map[s] ?? null;
}
